<template>
    <div v-if="mode === 'AVAILABLE'" :class="availabilityLabelClass">
        {{ availabilityLabel }}
    </div>
    <div v-else-if="availabilityLabel" class="text-body-2">
        <span class="mx-1">
            {{ availability.allocatedQuantity }}
        </span>
        <span class="mx-1 text-primary">
            {{ availability.bookedQuantity }}
        </span>
        <span class="mx-1 text-success">
            {{ availabilityLabel }}
        </span>
    </div>
</template>

<script setup lang="ts">
    const {availability} = defineProps<{
        availability: any
    }>()

    const availabilityLabel = computed(() => {
        if (!availability) {
            return null
        }
        switch (availability?.status) {
            case 'AVAILABLE':
                return availability.availableQuantity + (availability.canBeUndefined ? '*' : '')
            case 'UNLIMITED':
                return '∞'
            case 'RELEASED':
                return 'R'
            case 'OVERBOOKING':
                return availability.availableQuantity ? availability.availableQuantity + '+' : 'OR'
            case 'BLOCKED':
                return 'B'
            case 'TERMINATED_ALLOTMENT':
                return 'TA'
            default:
                return availability.terminateAllotment ? 'TA' : availability.blockout ? 'B' : ''
        }
    })

    const availabilityLabelClass = computed(() => {
        if (!availability) {
            return null
        }
        switch (availability?.status) {
            case 'RELEASED':
            case 'OVERBOOKING':
                return availability.availableQuantity ? '' : 'text-error font-weight-medium'
            case 'BLOCKED':
            case 'TERMINATED_ALLOTMENT':
                return 'text-error font-weight-medium'
            default:
                return !availability.terminateAllotment && !availability.blockout ? '' : 'text-error font-weight-medium'
        }
    })

    const mode = inject('availabilityTableViewMode')
</script>
